import React from 'react';

const CupboardLayoutCheckedIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8" cy="8" r="7" stroke="#7FC28D"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM7.35355 10.3536L11.3536 6.35355L10.6464 5.64645L7 9.29289L5.35355 7.64645L4.64645 8.35355L6.64645 10.3536L7 10.7071L7.35355 10.3536Z" fill="#7FC28D"/>
    </svg>
);

export default CupboardLayoutCheckedIcon;